import {Observable, Subscription} from 'rxjs';

import ISolution      from '../../../../Solutions/Shared/Interfaces/ISolution';
import ICaptionsStore from '../Interfaces/ICaptionsStore';

const subscribeToPlaybackReady = (
    playbackReady$: Observable<void>,
    solution: ISolution,
    captionsStore: ICaptionsStore
): Subscription =>
    playbackReady$
        .subscribe(() => {
            const textTracks = solution.textTracks;

            captionsStore.actions.loadTracks(textTracks);
        });

export default subscribeToPlaybackReady;